import React, { useState } from "react";
import {
  Provider as PaperProvider,
  Text,
  DefaultTheme,
} from "react-native-paper";
import { StyleSheet, View, ScrollView } from "react-native";
import {
  whiteColor,
  blackColor,
  greenBold,
  greyColor,
} from "../../common/colors";
import Button from "../../common/Button";
import Question from "../Question";
import questions_plPL from "./../../translations/pl_PL/questions";
import questions_enGB from "./../../translations/en_GB/questions";
import moment from "moment";
import ModalHeader from "../../common/ModalHeader";
import { actionCreators } from "../../test/action";
import { actionCreators as actionCreatorsSingleTest } from "./action";
import { connect } from "react-redux";
import first from "lodash/first";
import t from '../../translations';

const switchLanguageQuestions = (lang) => {
  switch(lang)
  {
    case 'pl_PL':
      return questions_plPL;
    case 'en_GB':
      return questions_enGB;
  }
}

const SingleTest = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const questions = switchLanguageQuestions(props.language);  

  const [questionId, setQuestionId] = useState(0);
  const [sliderValue, setSliderValue] = useState(50.1);
  const [answers, setAnswers] = useState([]);
  const [dataStart, setDataStart] = useState(moment().format());

  const selectSliderValueWhenWasAnswer = (QID) => {
    if (answers.findIndex((x) => x.question === QID) !== -1) {
      const ans = answers.filter((x) => x.question === QID);
      setSliderValue(first(ans).value);
    } else {
      setSliderValue(50.1);
    }
  };

  const onClickNextQuestion = () => {
    //ustawianie wartosci domyślnej TU MA BYĆ +2 wtedy jest ok
    selectSliderValueWhenWasAnswer(questionId + 2);
    const ans = answers;

    // znajdź taki sam wpis i jeśli istnieje to usuń tą wartość
    const ansFiltered = ans.filter((x) => x.question !== questionId + 1);

    // dodaj nową wartośc do tablicy
    ansFiltered.push({
      question: questionId + 1,
      value: sliderValue,
      dataStart,
      dataEnd: moment().format(),
    });

    setAnswers(ansFiltered);

    props.saveAnswers(ansFiltered, props.uid);

    if (questions.length - 1 > questionId) {
      setQuestionId(questionId + 1);
      setDataStart(moment().format());
    } else {
      props.saveTest(ansFiltered);
      props.onClose();
      props.goToUserPage();
      // setQuestion('done');
    }
  };

  const onClickPrevQuestion = () => {
    selectSliderValueWhenWasAnswer(questionId);

    if (questionId === "done") {
      setQuestionId(questions.length - 1);
    } else {
      if (questionId !== 0) {
        setQuestionId(questionId - 1);
      }
    }
  };
  return (
    <PaperProvider theme={theme}>
      <View style={styles.wrapper}>
        <View style={styles.container}>
          <ModalHeader
            back={onClickPrevQuestion}
            close={props.onClose}
            isBackDisabled={questionId === 0 ? true : false}
          />
          <ScrollView style={styles.scrollView}>
            {/* {question === 'done' ? 
                        <Results answers={answers} /> 
                    :   */}
            <>
              <Text style={styles.title}>
                {t('singleTest_title')} {questionId + 1} {t('singleTest_of')} {questions.length}{" "}
              </Text>
              <View style={styles.testRadio}>
                <View style={styles.questionsDesign}>
                  <Question
                    question={questions[questionId]}
                    sliderValue={sliderValue}
                    onSliderValue={setSliderValue}
                    button={() => (
                      <View style={styles.buttonContainer}>
                        <Button
                          value={t('singleTest_button')}
                          onPress={onClickNextQuestion}
                          disabled={sliderValue === 50.1}
                        />
                      </View>
                    )}
                  />
                </View>
              </View>
            </>
            {/* } */}
          </ScrollView>
        </View>
      </View>
    </PaperProvider>
  );
};

const mapStateToProps = (state) => {
  const uid = state.user && state.user.user.uid;
  const language = state.language && state.language
  return { uid, language };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...actionCreatorsSingleTest,
})(SingleTest);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 35,
    width: "100%",
    backgroundColor: whiteColor,
  },
  title: {
    textAlign: "center",
    fontSize: 24,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 24,
    paddingTop: 10,
  },
  contentOne: {
    backgroundColor: whiteColor,
    width: "100%",
    alignItems: "stretch",
  },
  titleOne: {
    textAlign: "left",
    fontSize: 16,
    lineHeight: 16,
    paddingTop: 20,
    letterSpacing: 0.15,
  },
  subtitleOne: {
    textAlign: "left",
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: 0.25,
    paddingBottom: 2,
    color: "#00000099",
  },
  subtitleOneRight: {
    textAlign: "right",
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: 0.25,
    paddingBottom: 0,
    color: "#00000099",
  },
  oneLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignContent: "center",
  },
  divider: {
    width: 300,
    height: 1,
    backgroundColor: greyColor,
  },
  questionsDesign: {
    alignItems: "center",
    justifyContent: "center",
  },
  testRadio: {
    padding: 0,
  },
  radio: {
    display: "flex",
    flexDirection: "row",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
  },
  messagecontainer: {
    backgroundColor: whiteColor,
    width: "100%",
    height: "100%",
    alignItems: "center",
    display: "flex",
  },
  back: {
    paddingRight: 100,
    alignItems: "flex-end",
    display: "flex",
  },
  close: {
    paddingLeft: 200,
    paddingRight: 100,
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: 390,
  },
  container: {
    height: "100%",
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    backgroundColor: whiteColor,
  },
  headermessage: {
    textAlign: "left",
    fontSize: 14,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingRight: 48,
    paddingLeft: 0,
    paddingTop: 24,
    paddingBottom: 24,
  },
  manywords: {
    alignItems: "stretch",
  },
  headertwomessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  headerthreemessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  textButton: {
    color: blackColor,
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 60,
    paddingLeft: 24,
    paddingRight: 24,
    color: blackColor,
  },
  button: {
    borderWidth: 1,
    width: "100%",
    borderColor: blackColor,
  },
  greenbold: {
    color: greenBold,
    fontWeight: "700",
  },
});
